
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      '& a': {
        color: 'inherit',
        textDecoration: 'underline',
      },
    },
    wrapper: {
      extend: theme.wrapper,
    },
    formContent: {
      margin: [100, -20],
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    formContent: {
      margin: [100, -10],
    },
  }

  return output
}

export default style
